import { mapEarliestAvailableSlots } from "../utils/mapEarliestAvailableSlots";
import { EarliestAvailableSlots } from "../EarliestAvailableSlots";
import { AvailableSlotRequest } from "./AvailableSlotsRequest";
import { AvailableSlotResponse } from "./AvailableSlotsResponse";
import { dispatchAnalyticsEvent } from "../../../utils";

export const getAvailableSlotOptions = async (
  baseUrl: string,
  request: AvailableSlotRequest,
  abortController: AbortController,
  onComplete?: () => void,
): Promise<EarliestAvailableSlots> => {
  try {
    const response = await fetch(`${baseUrl}/api/v1/available-slots`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(request),
      signal: abortController.signal,
    });

    if (onComplete) onComplete();

    if (response.status === 200) {
      dispatchAnalyticsEvent("pdp.postCodeFormSubmitted", {}, {});
      const slots = await response.json();
      return handleSuccess(slots, request);
    }

    return handleError(response.status, request);
  } catch (e) {
    if (
      abortController.signal.aborted &&
      abortController.signal.reason === "timeout"
    ) {
      return handleError(408, request);
    }

    return handleError(500, request);
  }
};

function handleSuccess(
  availableSlotResponse: AvailableSlotResponse,
  request: AvailableSlotRequest,
): EarliestAvailableSlots {
  const slots: EarliestAvailableSlots = {
    postcode: request.postcode,
  };

  const slotOptions = mapEarliestAvailableSlots(availableSlotResponse);
  if (slotOptions) {
    slots.slotOptions = slotOptions;
  }

  return slots;
}

function handleError(
  responseCode: number,
  request: AvailableSlotRequest,
): EarliestAvailableSlots {
  let retriable = false;
  let errorMessage = noDeliverySlotsMessage;

  if (responseCode === 422) {
    errorMessage = selectedServiceError;
    retriable = false;
  } else if (responseCode === 408) {
    errorMessage = technicalErrorMessage;
    retriable = true;
  } else if (responseCode === 504) {
    errorMessage = technicalErrorMessage;
    retriable = true;
  } else if (responseCode >= 500) {
    retriable = true;
    errorMessage = technicalErrorMessage;
  }

  //TODO Analytics

  return {
    postcode: request.postcode,
    error: {
      message: errorMessage,
      customerCanRetry: retriable,
    },
  };
}

export const technicalErrorMessage =
  "Sorry, we cannot check your delivery options at the moment. Please try again later.";

export const selectedServiceError =
  "Sorry, we can’t provide one or more of the services selected at your delivery address. Please remove these services to continue.";
export const noDeliverySlotsMessage =
  "We can't find any results for this postcode. Please try again.";
